import React from 'react';
import PropTypes from 'prop-types';

class TournamentName extends React.Component {
    static contextTypes = {
        info: PropTypes.object
    };

    render = () => {
        let tournamentsWithLogos = [46];

        let { name, id } = this.props;
        if (!id) return <span>{'\u00a0'}</span>;

        if (tournamentsWithLogos.indexOf(id) === -1) {
            return <span className="wdp-tournament-svg-logo_text">{name || '\u00a0'}</span>;
        }

        //Superleague for spdk

        return <span className="wdp-tournament-svg-logo_text">{name}</span>;
    };
}

export default TournamentName;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/TournamentName.js
 **/